
import { Component, Mixins } from "vue-property-decorator";
import { default as ObjectReferableContentMixin } from "./ObjectReferableContentMixin.vue";
import { IDocumentImageSource } from "../../../../../../../domain/document";
import { instanceOfIImageDrawable, IImageDrawable, instanceOfIDrawable, IDrawable } from "../../../../../../../domain/document/items";

@Component
export default class MediaReferableContentMixin extends Mixins(ObjectReferableContentMixin) {
  get imageDrawable(): IImageDrawable {
    return instanceOfIImageDrawable(this.item)
      ? this.item
      : undefined;
  }

  get imageSource(): IDocumentImageSource {
    return !!this.imageDrawable
      ? this.imageDrawable.imageSource
      : undefined;
  }

  get drawable(): IDrawable {
    return instanceOfIDrawable(this.item)
      ? this.item
      : undefined;
  }
}
